<template lang="pug">
  #signUpIndex.w-100(style="min-height: 100vh; overflow-y: scroll;")
    #appHeader.d-flex.align-items-center.justify-content-center
      b-img.h-100.w-100(
        fluid,
        :src="logoImg",
        alt="logo",
        v-if="member.CARD_NO"
        @click="backHandler('logo')"
      )
    .content-padding-top
    .qrcodeModal(v-show='showQRcodeModal' ref="qrcodeModal")
      img.rounded-circle.closeIcon.mt-3(
        v-lazy="iconUrl.IconClose",
        fluid,
        alt="Close Icon",
        @click="toggleShowModel()"
      )
      //- img.w-100.mt-3(:src='qrcode')
      qrcode(:value="qrcode" :options="{ width: qrcodeModalWidth }")
    .gray(v-show='showQRcodeModal')
    .container-width.mx-4.mt-3(v-if="member.CARD_NO")
      .userInfo.mt-2
        .row
          .col-4
            img.w-100.border-round(:src='img')
          .col-8.d-flex.align-items-center
            div.title-EP(v-if="member.CARD_NO === 'EP'")
              div.title-font-size-lg {{ member.C_NAME }}
              div {{ member.display_name }}
            div.title-VP(v-if="member.CARD_NO === 'VP'")
              div.title-font-size-lg {{ member.C_NAME }}
              div {{ member.display_name }}
            div.title-SP(v-if="member.CARD_NO === 'SP'")
              div.title-font-size-lg {{ member.C_NAME }}
              div {{ member.display_name }}
            div.title-DP(v-if="member.CARD_NO === 'DP'")
              div.title-font-size-lg {{ member.C_NAME }}
              div {{ member.display_name }}

      .cardArea.mt-3.w-100.position-relative.card-EP(v-if="member.CARD_NO === 'EP'")
        //.bg1.w-100(:style="{ 'background-image': 'url(' + bg1 +')' }" style="background-size: 100%;")
          .row
            .col-5
              img.w-100(:src='lv1')
        img.cardBg.w-100.position-relative(v-if="member.CARD_NO" :src="require(`@/assets/images/card/memberCardLevel${member.CARD_NO}.png`)")
        .cardInfo.position-absolute.w-100.h-100.d-flex.align-items-center.no-gutters
          .col-5.d-flex.align-items-center.justify-content-center
            img(v-if="member.CARD_NO" :src="require(`@/assets/images/card/memberLevel${member.CARD_NO}.png`)" style='width: 56px; height: 80px;')
            div.mt-2.cardType
              span(style='font-size: 18px;') 員工
            div.mt-1.effectiveDate(v-if='smallSize')
              span(style='font-size: 13px;') {{ moment(member.APP_DATE).format('YYYY/MM/DD') }}~
              div
                span(style='font-size: 13px;') {{ moment(member.EXP_DATE).format('YYYY/MM/DD') }}
            div.mt-2.effectiveDate(v-else)
              span(style='font-size: 13px;') {{ moment(member.APP_DATE).format('YYYY/MM/DD') }}~{{ moment(member.EXP_DATE).format('YYYY/MM/DD') }}
          .col-7.d-flex.align-items-center
            div.mr-auto.ml-3.fontSmall
              span 紅利點數
            div.ml-auto.mr-3.fontBig
              span {{ numberFormat(member.Y_POINT) }}
            div.mr-auto.ml-3.fontSmall
              span 今年到期點數
            div.ml-auto.mr-3.fontBig
              span {{ numberFormat(member.POINT_LY) }}
            //div.ml-auto.mr-3.white(style='font-size: 12px;')
              span 累積消費{{ member.C_TAMT_TY }}元
            //div.ml-auto.mr-3.white(style='font-size: 12px; text-align:right')
              span {{ member.REMARK }}
      .cardArea.mt-3.w-100.position-relative.card-VP(v-else-if="member.CARD_NO === 'VP'")
        //.bg1.w-100(:style="{ 'background-image': 'url(' + bg1 +')' }" style="background-size: 100%;")
          .row
            .col-5
              img.w-100(:src='lv1')
        img.cardBg.w-100.position-relative(v-if="member.CARD_NO" :src="require(`@/assets/images/card/memberCardLevel${member.CARD_NO}.png`)" style='border-radius: 23px;')
        .cardInfo.position-absolute.w-100.h-100.d-flex.align-items-center.no-gutters
          .col-5.d-flex.align-items-center.justify-content-center
            img(v-if="member.CARD_NO" :src="require(`@/assets/images/card/memberLevel${member.CARD_NO}.png`)" style='width: 56px; height: 80px;')
            div.mt-2.cardType
              span(style='font-size: 18px;') 黃金會員
            div.mt-1.effectiveDate(v-if='smallSize')
              span(style='font-size: 13px;') {{ moment(member.APP_DATE).format('YYYY/MM/DD') }}~
              div
                span(style='font-size: 13px;') {{ moment(member.EXP_DATE).format('YYYY/MM/DD') }}
            div.mt-2.effectiveDate(v-else)
              span(style='font-size: 13px;') {{ moment(member.APP_DATE).format('YYYY/MM/DD') }}~{{ moment(member.EXP_DATE).format('YYYY/MM/DD') }}
          .col-7.d-flex.align-items-center
            div.mr-auto.ml-3.white.fontSmall
              span 紅利點數
            div.ml-auto.mr-3.white.fontBig
              span {{ numberFormat(member.Y_POINT) }}
            div.mr-auto.ml-3.white.fontSmall
              span 今年到期點數
            div.ml-auto.mr-3.white.fontBig
              span {{ numberFormat(member.POINT_LY) }}
            div.ml-auto.mr-3(style='font-size: 12px;')
              span 累積消費{{ member.C_TAMT_TY ? numberFormat(member.C_TAMT_TY) : 0 }}元
            div.ml-auto.mr-3(style='font-size: 12px; text-align:right')
              span {{ member.REMARK }}
      .cardArea.mt-3.w-100.position-relative.card-SP(v-else-if="member.CARD_NO === 'SP'")
        //.bg1.w-100(:style="{ 'background-image': 'url(' + bg1 +')' }" style="background-size: 100%;")
          .row
            .col-5
              img.w-100(:src='lv1')
        img.cardBg.w-100.position-relative(v-if="member.CARD_NO" :src="require(`@/assets/images/card/memberCardLevel${member.CARD_NO}.png`)" style='border-radius: 23px;')
        .cardInfo.position-absolute.w-100.h-100.d-flex.align-items-center.no-gutters
          .col-5.d-flex.align-items-center.justify-content-center
            img(v-if="member.CARD_NO" :src="require(`@/assets/images/card/memberLevel${member.CARD_NO}.png`)" style='width: 56px; height: 80px;')
            div.mt-2.cardType
              span.white(style='font-size: 18px;') 白金會員
            div.mt-1.effectiveDate(v-if='smallSize')
              span.white(style='font-size: 13px;') {{ moment(member.APP_DATE).format('YYYY/MM/DD') }}~
              div
                span.white(style='font-size: 13px;') {{ moment(member.EXP_DATE).format('YYYY/MM/DD') }}
            div.mt-2.effectiveDate(v-else)
              span(style='font-size: 13px; color: #FFFFFF') {{ moment(member.APP_DATE).format('YYYY/MM/DD') }}~{{ moment(member.EXP_DATE).format('YYYY/MM/DD') }}
          .col-7.d-flex.align-items-center
            div.mr-auto.ml-3.white.fontSmall
              span 紅利點數
            div.ml-auto.mr-3.white.fontBig
              span {{ numberFormat(member.Y_POINT) }}
            div.mr-auto.ml-3.white.fontSmall
              span 今年到期點數
            div.ml-auto.mr-3.white.fontBig
              span {{ numberFormat(member.POINT_LY) }}
            div.ml-auto.mr-3.white(style='font-size: 12px;')
              span 累積消費{{ member.C_TAMT_TY ? numberFormat(member.C_TAMT_TY) : 0 }}元
            div.ml-auto.mr-3.white(style='font-size: 12px; text-align:right')
              span {{ member.REMARK }}
      .cardArea.mt-3.w-100.position-relative.card-DP(v-else-if="member.CARD_NO === 'DP'")
        //.bg1.w-100(:style="{ 'background-image': 'url(' + bg1 +')' }" style="background-size: 100%;")
          .row
            .col-5
              img.w-100(:src='lv1')
        img.cardBg.w-100.position-relative(v-if="member.CARD_NO" :src="require(`@/assets/images/card/memberCardLevel${member.CARD_NO}.png`)" style='border-radius: 23px;')
        .cardInfo.position-absolute.w-100.h-100.d-flex.align-items-center.no-gutters
          .col-5.d-flex.align-items-center.justify-content-center
            img(v-if="member.CARD_NO" :src="require(`@/assets/images/card/memberLevel${member.CARD_NO}.png`)" style='width: 56px; height: 80px;')
            div.mt-2.cardType
              span(style='font-size: 18px;') 鑽石會員
            div.mt-1.effectiveDate(v-if='smallSize')
              span(style='font-size: 13px;') {{ moment(member.APP_DATE).format('YYYY/MM/DD') }}~
              div
                span(style='font-size: 13px;') {{ moment(member.EXP_DATE).format('YYYY/MM/DD') }}
            div.mt-2.effectiveDate(v-else)
              span(style='font-size: 13px;') {{ moment(member.APP_DATE).format('YYYY/MM/DD') }}~{{ moment(member.EXP_DATE).format('YYYY/MM/DD') }}
          .col-7.d-flex.align-items-center
            div.mr-auto.ml-3.fontSmall
              span 紅利點數
            div.ml-auto.mr-3.fontBig
              span {{ numberFormat(member.Y_POINT) }}
            div.mr-auto.ml-3.fontSmall
              span 今年到期點數
            div.ml-auto.mr-3.fontBig
              span {{ numberFormat(member.POINT_LY) }}
            //div.ml-auto.mr-3(style='font-size: 12px;')
              span 累積消費{{ member.C_TAMT_TY }}元
            //div.ml-auto.mr-3(style='font-size: 12px; text-align:right')
              span {{ member.REMARK }}
      .qrcodeArea.row.no-gutters.align-items-center(@click='toggleShowModel()')
        .col-6
          //- img.w-100(:src='qrcode')
          qrcode(:value="qrcode" :options="{ width: 200 }")
        .col-6.text-center
          div.font-weight-bold 會員 QRcode
          div.mt-2
            i.fas.fa-search-plus.mr-2
            span 點擊放大
        label.redRemind 若已於會員APP綁定發票載具，發票將自動存至財政部。

      .btnArea.mx-5.pb-3
        img.mt-3.w-100(:src="require('@/assets/images/card/couponBtn.png')" @click='routeToCoupon()')
        img.mt-3.w-100(:src="require('@/assets/images/card/pointBtn.png')" @click='routeToPointSearch()')
        img.mt-3.w-100(:src="require('@/assets/images/card/recordBtn.png')" @click='routeToShoppingRecord()')
        img.mt-3.w-100(:src="require('@/assets/images/card/memberAlterBtn.png')" @click='routeToMemberAlter()')

</template>

<script>
  import IconCloseUrl from "@/assets/images/icon/icon_close.png";
  import defaultUserPictureUrl from "@/assets/images/default/defaultPhotoSticker.png";
  import { M_CARD_SHOPPING_RECORD_INDEX } from "@/router/member/card";
  import defaultLogoUrl from "@/assets/images/logo/logo.png";

  const moment = require("moment");

  export default {
    name: "SignUpIndex",
    components: {},
    props: {
      sa_id: {
        type: [String, Number],
        required: false,
      },
      store_id: {
        type: [String, Number],
        required: false,
      },
      utm_source: {
        type: [String, Number],
        required: false,
      },
    },
    data() {
      return {
        img: defaultUserPictureUrl,
        showQRcodeModal: false,
        iconUrl: {
          IconClose: IconCloseUrl,
        },
        member: {
          display_name: null,
          picture_url: null,
          C_NAME: null,
          CC_NO: null,
          CARD_NO: null,
          APP_DATE: null,
          EXP_DATE: null,
          VEHICLE: null,
          C_MOB: null,
          REMARK: null,
          Y_POINT: null,
          POINT_LY: null,
          C_TAMT_TY: null,
        },
        defaultLogo: `this.src="${defaultLogoUrl}"`,
        logoImg: defaultLogoUrl,
        utm_source2: null,
        qrcodeModalWidth: 280,
      };
    },
    mounted() {
      const vm = this;
      vm.$store.commit("toggleLoading", true);
      vm.$store.dispatch("member_card/getInfoHandler").then((res) => {
        vm.$store.commit("toggleLoading", false);
        vm.member = res.data;
        // vm.member.VEHICLE = '\\' + vm.member.VEHICLE;
        vm.changeImage(res.data.picture_url);
        vm.changeLogoImage();
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (params.utm_source) vm.utm_source2 = params.utm_source;
      });
    },
    methods: {
      moment(val) {
        return moment(val);
      },
      backHandler(type) {
        const vm = this;
        // icon 回上一頁 logo 回工作管理頁
        if (type === "icon") {
          vm.$router.go(-1);
        } else {
          if (vm.targetRouterName) {
            const targetInfo = {
              name: vm.targetRouterName,
              params: vm.targetRouterParams,
            };
            if (!vm.targetRouterParams) {
              delete targetInfo.params;
            }
            vm.$router.push(targetInfo);
          }
        }
      },
      changeLogoImage() {
        const vm = this;
        try {
          vm.logoImg = require(`@/assets/images/card/memberCardHeader${vm.member.CARD_NO}.png`);
        } catch (e) {
          vm.logoImg = defaultLogoUrl;
        }
      },
      toggleShowModel() {
        const vm = this;
        vm.showQRcodeModal = !vm.showQRcodeModal;
        vm.$nextTick(() => {
          vm.qrcodeModalWidth = vm.$refs.qrcodeModal.offsetWidth - 5;
        });
      },
      changeImage(imageUrl) {
        const vm = this;
        try {
          vm.img = imageUrl;
        } catch (e) {
          vm.img = defaultUserPictureUrl;
        }
      },
      routeToShoppingRecord() {
        const vm = this;
        if (vm.utm_source2) {
          vm.$gtm.trackEvent({
            event: "ga-event", // Event type [default = 'interaction'] (Optional)
            eventCategory: "電子會員卡",
            eventAction: "消費紀錄",
            eventLabel: vm.utm_source2 ? vm.utm_source2 : "",
          });
          vm.$router.push({
            name: M_CARD_SHOPPING_RECORD_INDEX,
            params: { CARD_NO: vm.member.CARD_NO, utm_source: vm.utm_source2 },
          });
          return;
        }

        vm.$gtm.trackEvent({
          event: "ga-event", // Event type [default = 'interaction'] (Optional)
          eventCategory: "電子會員卡",
          eventAction: "消費紀錄",
          eventLabel: vm.utm_source ? vm.utm_source : "",
        });
        vm.$router.push({
          name: M_CARD_SHOPPING_RECORD_INDEX,
          params: { CARD_NO: vm.member.CARD_NO, utm_source: vm.utm_source },
        });
      },
      routeToCoupon() {
        const vm = this;
        if (vm.utm_source2) {
          vm.$gtm.trackEvent({
            event: "ga-event", // Event type [default = 'interaction'] (Optional)
            eventCategory: "電子會員卡",
            eventAction: "我的優惠券",
            eventLabel: vm.utm_source2 ? vm.utm_source2 : "",
          });
          window.location = `${process.env.VUE_APP_COUPON_URL}${
            vm.utm_source2 ? `?utm_source=${vm.utm_source2}` : ""
          }`;
          return;
        }

        vm.$gtm.trackEvent({
          event: "ga-event", // Event type [default = 'interaction'] (Optional)
          eventCategory: "電子會員卡",
          eventAction: "我的優惠券",
          eventLabel: vm.utm_source ? vm.utm_source : "",
        });
        window.location = `${process.env.VUE_APP_COUPON_URL}${
          vm.utm_source ? `?utm_source=${vm.utm_source}` : ""
        }`;
      },
      routeToPointSearch() {
        window.location = process.env.VUE_APP_POINT_SEARCH_URL;
      },
      routeToMemberAlter() {
        window.location = process.env.VUE_APP_MEMBER_ALTER_URL;
      },
      numberFormat(number) {
        const str = number.toString().split(".");
        if (str[0] === "0") return 0;
        str[0] = str[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return str[0];
      },
    },
    computed: {
      smallSize() {
        return window.innerWidth < 400;
      },
      qrcode() {
        const vm = this;
        // vm.qrcode = `{"CC_NO":"${this.$route.params.CC_NO}","VEHICLE":"${this.$route.params.VEHICLE ? '\\' + this.$route.params.VEHICLE : ''}","mobile":"${this.$route.params.C_MOB}","coupon_no":"${this.couponDetailInfo.coupon_no}"}`
        // return `https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl={"CC_NO":"${vm.member.CC_NO}","VEHICLE":"${vm.member.VEHICLE}","mobile":"${vm.member.C_MOB}"}&choe=UTF-8`;
        return `{"CC_NO":"${vm.member.CC_NO}","VEHICLE":"${
          vm.member.VEHICLE ? "\\" + vm.member.VEHICLE : ""
        }","mobile":"${vm.member.C_MOB}"}`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .border-round {
    border-radius: 50%;
  }
  .font12 {
    font-size: 12px;
  }
  .font13 {
    font-size: 12px;
  }
  .font14 {
    font-size: 12px;
  }
  .font15 {
    font-size: 12px;
  }

  .cardBg {
    height: 192px;
  }
  .cardInfo {
    top: 0;
    .col-4 {
      flex-direction: column;
      height: 80%;
      img {
        max-width: 56px;
        max-height: 80px;
      }
      .cardType {
        font-size: 1rem;
      }
      .effectiveDate {
        font-size: 1rem;
      }
    }
    .col-5 {
      flex-direction: column;
      height: 80%;
      img {
        max-width: 56px;
        max-height: 80px;
      }
      .cardType {
        font-size: 1rem;
      }
      .effectiveDate {
        font-size: 1rem;
      }
    }
    .col-7 {
      flex-direction: column;
      height: 80%;
      .fontSmall {
        font-size: 16px;
      }
      .fontBig {
        font-size: 22px;
      }
    }
    .col-8 {
      flex-direction: column;
      height: 80%;
      .fontSmall {
        font-size: 16px;
      }
      .fontBig {
        font-size: 22px;
      }
    }
  }

  .white {
    color: #ffffff;
  }

  @media (min-width: 320px) {
  }

  .qrcodeModal {
    position: absolute;
    width: 90%;
    top: 50%;
    left: 5%;
    transform: translateY(-50%);
    z-index: 3;
  }

  .closeIcon {
    width: 40px;
    right: 0;
    position: absolute;
  }
  .gray {
    width: 100%;
    height: 100%;
    background-color: #000000;
    opacity: 0.6;
    z-index: 2;
    position: fixed;
    max-width: 434px;
  }

  .content-padding-top {
    padding-top: 72px;
  }

  .card-EP {
    .cardInfo {
      .col-4 {
        .cardType {
          color: #ffffff;
        }
        .effectiveDate {
          color: #ffffff;
          opacity: 0.6;
        }
      }
      .col-5 {
        .cardType {
          color: #ffffff;
        }
        .effectiveDate {
          color: #ffffff;
          opacity: 0.6;
        }
      }
      .col-7 {
        border-left: 2px solid #c9a056;
        .fontSmall {
          color: #ffffff;
          opacity: 0.6;
        }
        .fontBig {
          color: #ffffff;
        }
      }
      .col-8 {
        border-left: 2px solid #c9a056;
        .fontSmall {
          color: #ffffff;
          opacity: 0.6;
        }
        .fontBig {
          color: #ffffff;
        }
      }
    }
  }
  .card-VP {
    .cardInfo {
      .col-4 {
        .cardType {
          color: #000000;
        }
      }
      .col-5 {
        .cardType {
          color: #000000;
        }
      }
      .col-7 {
        border-left: 2px solid #867050;
        .fontSmall {
          color: #000000;
        }
      }
      .col-8 {
        border-left: 2px solid #867050;
        .fontSmall {
          color: #000000;
        }
      }
    }
  }
  .card-SP {
    .cardInfo {
      .col-4 {
      }
      .col-5 {
      }
      .col-7 {
        border-left: 2px solid rgba(68, 68, 68, 0.5);
        .fontBig {
          color: #000000;
        }
      }
      .col-8 {
        border-left: 2px solid rgba(68, 68, 68, 0.5);
        .fontBig {
          color: #000000;
        }
      }
    }
  }
  .card-DP {
    .cardInfo {
      .col-4 {
        .cardType {
          color: #a48364;
        }
        .effectiveDate {
          color: #a48364;
        }
      }
      .col-5 {
        .cardType {
          color: #a48364;
        }
        .effectiveDate {
          color: #a48364;
        }
      }
      .col-7 {
        border-left: 2px solid rgba(164, 131, 100, 0.5);
        color: #a48364;
        .fontBig {
          color: #ffffff;
        }
      }
      .col-8 {
        border-left: 2px solid rgba(164, 131, 100, 0.5);
        color: #a48364;
        .fontBig {
          color: #ffffff;
        }
      }
    }
  }

  .title-EP {
    color: #444444;
  }
  .title-VP {
    color: #867050;
  }
  .title-SP {
    color: #444444;
  }
  .title-DP {
    color: #a48364;
  }
</style>
